export default __webpack_public_path__ + "static/patrykj-8528081b96abd517142bb6a29d9a407e.jpg";